export enum ParameterSectionType {
    SECTION = 'SECTION',
    PARAMETER = 'PARAMETER',
}

export enum ParameterSectionParameterType {
    IMAGES = 'IMAGES',
    NUMBER = 'NUMBER',
    NUMBER_MIN_MAX = 'NUMBER_MIN_MAX',
    PRODUCTS = 'PRODUCTS',
    TEXT = 'TEXT',
    QUANTITY = 'QUANTITY',
    PRICE = 'PRICE',
    SUPPLIER = 'SUPPLIER',
    DATE = 'DATE',
    WEIGHT = 'WEIGHT',
}

export enum ParameterVisibility {
    BOTH = 0,
    BUDGET_ONLY = 1,
    ELEMENT_ONLY = 2,
}

export interface ParameterSectionBaseModel {
    id?: string;
    key: string;
    title?: string | null;
    type: ParameterSectionType;
    unitId?: string | null;
    unitSymbol?: string | null;
    familyId?: string;
    familyName?: string;
    parameterType?: ParameterSectionParameterType | null;
    parameterName?: string | null;
    parameterFamilyId?: string | null;
    parameterIsRequired?: boolean;
    isEligibleForDiscount?: boolean;
    requiresTreatment?: boolean;
    visibility?: ParameterVisibility;
    averageParameterId?: string | null;
    isOpen: boolean;
    closed: boolean;
    parentKey: string | null;
    relativeKey?: string | null;
    formulaExpression?: string | null;
    catalogParameterId?: string | null;
}
